export default __webpack_public_path__ + "static/media/StoryOpen.5fb2b0c2.png";